<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/137teL8/tc-custom/9781453223024.jpg?1702669348422" alt="This image is the cover for the book Taste of Honey, The Carson Springs Trilogy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Taste of Honey, The Carson Springs Trilogy
      </h1>
      <p class="bookDescription body article font2">
        <b>A divorced woman revisits a life-changing decision and confronts her church in this novel by the <i>New York Times</i>–bestselling author of <i>Stranger in Paradise</i>.</b><br/>  Gerry Fitzgerald kneels before the altar, moments away from the most important decision of her life. She is about to take her vows in the sisterhood of God, and yet she is not at peace. Anything but. Doubt fills her heart and she is torn with guilt. She found illicit passion in the arms of Father Jim, and now she is pregnant with the baby they have conceived. Is she ready to give it up? When it is her turn to speak, she runs. She has the child but gives her up for adoption, and thirty years later begins to question her decision. A reunion with her long-lost daughter reopens old wounds, and she begins to consider confronting Father Jim about his baby. Once Gerry ran from the church; this time the church will fight back. <i>This ebook features an illustrated biography of Eileen Goudge including rare photos from the author’s personal collection.</i><br/><br/> Taste of Honey<i> is the 2nd book in the Carson Springs Novels, but you may enjoy reading the series in any order.</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Eileen Goudge
      </h2>
      
      <p class="authorDescription body article">Eileen Goudge (b. 1950) is one of the nation&rsquo;s most successful authors of women&rsquo;s fiction. She began as a young adult writer, helping to launch the phenomenally successful <i>Sweet Valley High</i> series, and in 1986 she published her first adult novel, the <i>New York Times </i>bestseller <i>Garden of Lies</i>.&#160;She has since published twelve more novels, including the three-book saga of Carson Springs, and <i>Thorns of Truth</i>, a sequel to <i>Gardens of Lies</i>. She lives and works in New York City. <BR></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?59603f44